// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The console tracker token.
 */
export const IConsoleTracker = new Token('@jupyterlab/console:IConsoleTracker');
//# sourceMappingURL=tokens.js.map